/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { teamsControllerCreate } from "./teamsControllerCreate";
import { teamsControllerFindAll } from "./teamsControllerFindAll";
import { teamsControllerFindOne } from "./teamsControllerFindOne";
import { teamsControllerFindProjectsInTeam } from "./teamsControllerFindProjectsInTeam";
import { teamsControllerRemove } from "./teamsControllerRemove";
import { teamsControllerUpdate } from "./teamsControllerUpdate";

export function teamsService() {
  return { teamsControllerCreate, teamsControllerFindAll, teamsControllerFindOne, teamsControllerUpdate, teamsControllerRemove, teamsControllerFindProjectsInTeam }
}